var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2460_2500",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 17,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0296936 4.77246H16.5816V42.6807H0.0296936V4.77246Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2460_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9154 7.56349C14.8666 6.48048 15.7414 5.56407 16.5746 4.78634C2.5084 4.33595 6.60469 14.5065 1.99453 24.8305C-3.28203 36.7305 2.61953 41.2643 11.4086 42.6807C10.1813 41.2179 9.17981 39.5797 8.4375 37.8205C2.76523 30.6486 5.06328 17.5752 13.9154 7.56349Z",
    fill: "#EFE812"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7621 20.2412C46.101 24.5869 43.6977 28.6111 40.6596 32.1344C38.2239 35.0945 35.3062 37.6225 32.0295 39.6119C28.2242 42.0232 23.8015 43.2796 19.2969 43.2291C16.6668 43.2527 14.0389 43.0694 11.4375 42.6807C12.8817 44.4056 14.672 45.8079 16.6926 46.7969C29.4121 52.9492 30.2104 41.5274 43.6652 35.7301C51.2189 32.4738 51.2469 26.1141 47.7545 20.2404M32.0295 8.36896C33.8709 8.69119 35.6451 9.32017 37.2783 10.2297C41.5569 12.6353 45.162 16.078 47.7621 20.2412C50.0531 13.7844 48.984 8.71603 43.9781 7.79982C38.4656 6.79298 34.1609 6.46681 30.023 3.57853C24.927 0.0375141 20.4557 1.19005 16.582 4.79337L17.4219 4.82814C22.7957 5.14747 27.9334 6.21662 32.002 8.35509",
    fill: "#EDE70A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9154 7.56345C5.06328 17.5752 2.76524 30.6494 8.46621 37.8205C7.14759 34.7072 6.57211 31.3297 6.78538 27.9554C6.99865 24.5811 7.99481 21.3029 9.69493 18.3804C14.4922 10.3824 24.1211 6.91091 32.0295 8.36892C27.9332 6.20271 22.7955 5.1613 17.4494 4.84197L16.6096 4.80017C15.6641 5.67381 14.7648 6.59615 13.9154 7.56345Z",
    fill: "#DEC21C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2783 10.2148C35.6442 9.31036 33.87 8.68616 32.0295 8.36816C37.4172 11.2002 40.9928 16.0049 40.9928 23.6008C40.9615 26.8071 40.1242 29.954 38.5579 32.7518C36.9915 35.5496 34.7465 37.9085 32.0295 39.6111C35.3078 37.6238 38.2257 35.0955 40.6596 32.1336C43.6977 28.6103 46.101 24.5861 47.7621 20.2404C45.1638 16.0721 41.5585 12.6244 37.2783 10.2148Z",
    fill: "#E5CB22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0295 8.36893C24.1211 6.91092 14.4922 10.3824 9.69414 18.3459C7.98691 21.2721 6.98678 24.5566 6.77345 27.9377C6.56013 31.3188 7.13951 34.7029 8.46543 37.8205C9.20524 39.5811 10.2071 41.2197 11.4369 42.6806C14.0383 43.0693 16.6662 43.2527 19.2963 43.2291C23.8011 43.2797 28.224 42.0232 32.0295 39.6119C34.747 37.9097 36.9923 35.551 38.5587 32.7531C40.1252 29.9551 40.9622 26.808 40.9928 23.6015C40.9928 16.006 37.4172 11.2015 32.0295 8.36893ZM31.1408 36.0015C28.2161 37.8802 24.6665 38.5243 21.2682 37.7931C17.8698 37.0619 14.8993 35.0149 13.0061 32.0996C9.07636 26.0385 11.0203 18.2138 16.9141 14.0482C23.5098 9.36072 31.9662 11.2086 35.0488 17.95C38.0551 24.5179 37.2289 32.1066 31.14 36.0015",
    fill: "#CCA727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6803 37.9715L42.3379 42.4186V25.4883L34.6803 37.9715Z",
    fill: "#D7D7D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 25.4883V42.4186L49.9953 37.9715L42.3379 25.4883Z",
    fill: "#878787"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.34 34.5529L49.9953 37.9709L42.34 42.4168V34.5529Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 34.5519H42.34V42.4156L42.3379 42.4178L34.6801 37.9707L42.3379 34.5519Z",
    fill: "#999999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6803 39.3981L42.3379 50V43.843L34.6803 39.3981Z",
    fill: "#D7D7D7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 43.843V50L50 39.3983L42.3379 43.843Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36);
export default __webpack_public_path__ + "static/media/36.6c08d9ec056448e83474d3a76f19b35e.svg";
export { ForwardRef as ReactComponent };